import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CtaBlock } from './CtaBlock';
import { forWhom } from '../data/content';
export function ForWhom() {
  return <section className="border-t border-ink-700 bg-ink-900 px-4 py-12 sm:px-6 sm:py-16" data-id="element-122" data-mp="33ix5g3wolqcc">
      <div className="mx-auto w-full max-w-3xl" data-id="element-123" data-mp="2yjkkxpta8vcx">
        <SectionHeading eyebrow="Ist das etwas für dich?" title="Das Meister-System wurde für dich entwickelt, wenn…" data-id="element-124" data-mp="2ykvoppmqa341" />

        <ul className="mt-8 divide-y divide-ink-700 overflow-hidden rounded-2xl border border-ink-700 bg-ink-800" data-id="element-125" data-mp="3r76lep77rjvk">
          {forWhom.map(item => <li key={item} className="flex gap-3 px-4 py-3.5 sm:px-5" data-id="element-126" data-mp="3men87tcfuqra">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand" data-id="element-127" data-mp="3hh3wb037qq2i">
                <CheckIcon className="h-3.5 w-3.5 text-ink-950" aria-hidden="true" data-id="element-128" data-mp="isy267ql05g2" />
              </span>
              <span className="text-[15px] leading-snug text-white/85" data-id="element-129" data-mp="dytshgpxljba">{item}</span>
            </li>)}
        </ul>

        <p className="mt-5 text-center text-[15px] font-semibold text-white" data-id="element-130" data-mp="1t61nid72ez2j">
          Wenn du dich in einem dieser Punkte wiedererkennst, ist dieses System für dich.
        </p>

        <CtaBlock label="Ja, das bin ich — Zugang sichern" showTimer={false} note="Lebenslanger Zugang · 7 Tage Garantie" className="mt-7" data-id="element-131" data-mp="1fck36q6k1ibg" />
      </div>
    </section>;
}